import { List, Typography, Row} from 'antd';
import {
WarningOutlined, EditOutlined, CloseOutlined, RightOutlined
} from '@ant-design/icons';
import {useTranslation} from "react-i18next";
import IconButton from "../buttons/IconButton";
import DataCard from './DataCard';

const { Text} = Typography;

/**
 * Standard list of data cards
 *  @items array of daya objects, must contain attributes that work with header and detail for example
 *  @editItem edit function called via edit pencil icon to right of detail section
 *  @deleteItem delete function called vis X icon in header
 *  @actionItem will show right chevron to right of detail section and whole row can be actioned
 *              by calling the passed in function (usually instead of edit & delete)
 *              (item can be given readOnly property to control conditional action - not clickable if read only)
 *  @title used for no data message if set to show (showNoDataMessage)
 */
const DataCards = ({items, editItem, deleteItem, deleteIcon, actionItem, header, wrapHeaders = false, detail, title, borderColour, backgroundColour, subHeader, showNoDataMessage = true, overrideNoDataMessage = null}) => {
    const {t} = useTranslation();

    const getStyles = (item) => {
        let styles = null;
        if(borderColour && borderColour(item) !== 'none') {
            styles = { ...styles, 'header': {'border-width': '3px', 'border-color': borderColour(item)} };
        }
        let body = null;
        if(backgroundColour && backgroundColour(item) !== 'none') {
            body = { ...body, 'background-color': backgroundColour(item)};
        }
        if (actionItem && item && !item.readOnly) {
            body = {...body, 'cursor': 'pointer'};
        }
        if(body)
        {
            styles = { ...styles, 'body' : body};
        }
        return styles;
    }
    return (
        <div style={{'width':'100%'}}>
            {
                items.length > 0
                ?
                <List>
                  {items.map(item => (
                  <List.Item key={items.indexOf(item)}>
                      <DataCard
                          extra={deleteItem ? <IconButton icon={deleteIcon ? deleteIcon : <CloseOutlined/>}
                                                          onClick={event => {event.stopPropagation(); deleteItem(items.indexOf(item))}}/> : <></>}
                          header={header && header(item)}
                          wrapHeader={wrapHeaders}
                          subHeader={subHeader && subHeader(item)}
                          styles={getStyles(item)}
                          onClick={(actionItem && item && !item.readOnly) ? () => actionItem(item) : null}
                      >
                              {detail(item)}
                              <div>
                                  {editItem ? <IconButton icon={<EditOutlined/>} onClick={() => editItem(item)}/> : <></>}
                                  {(actionItem && item && !item.readOnly) ? <IconButton icon={<RightOutlined/>}/> : <></>}
                              </div>
                      </DataCard>
                  </List.Item>
                      ))}
                </List>
                :
              // No data - give standard you have not recorded x message using title or passed in message if overridden or nothing if tuned off
              showNoDataMessage
                  ? <div>
                      <Row align="middle">
                          <WarningOutlined style={{ fontSize: '20px', marginRight: '5px'}} />
                          <Text>{overrideNoDataMessage ? overrideNoDataMessage : t('message.no_data_yet',{0:title})}</Text>
                      </Row>
                    </div>
                  : <></>
            }
        </div>
    );
}

export default DataCards;